module.exports = __webpack_public_path__ + "entry-41b28522/deutsche-post-098f2ac44bd2ded3702c91318756cb7e.webp";